import {hitType} from "../../analytics.helper";
import {playerActionTypes} from "../../../../_constants/actions/analytics/playerActionTypes";

// UTILITY-HELPERS ##########################################################

// generic player event that accepts the event and player identifier
const genericPlayerEvent = (playerEvent, values={}) => {
	return {
		event: playerEvent,
		hitType: hitType.EVENT,
		values: values,
	};
};

// EVENTS ##########################################################

// player load event(s)
const onPlayLoad          	= (action)  => genericPlayerEvent(playerActionTypes.PLAYER_PLAY_LOAD, action.userType);
const onPlayResume        	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_PLAY_RESUME);
const onPlayPause         	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_PLAY_PAUSE);
const onPlayForward       	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_SKIP_FORWARD);
const onPlayBack          	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_SKIP_BACKWARD);
const onVolumeChange      	= (action)  => genericPlayerEvent(playerActionTypes.PLAYER_VOLUME_CHANGE, action.volume);
const onSpeedChange       	= (action)  => genericPlayerEvent(playerActionTypes.PLAYER_SPEED_CHANGE, action.speed);
const onFullViewLoad      	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_FULL_VIEW_LOAD);
const onFullViewExit      	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_FULL_VIEW_EXIT);
const onGistShow          	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_GIST_SHOW);
const onGistHide          	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_GIST_HIDE);
const onGistLogoRedirect  	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_GIST_LOGO_REDIRECT);
const onGistWordPlay      	= (action)  => genericPlayerEvent(playerActionTypes.PLAYER_GIST_WORD_PLAY, action.weight);
const onGistWordHint      	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_GIST_HINT_SHOW);
const onChapterChange     	= (action)  => genericPlayerEvent(playerActionTypes.PLAYER_CHAPTER_CHANGE, action.invokerType);
const onTocViewLoad       	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_TOC_VIEW_LOAD);
const onTocToChapter      	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_TOC_VIEW_TO_CHAPTER);
const onTocViewClose      	= ()        => genericPlayerEvent(playerActionTypes.PLAYER_TOC_VIEW_CLOSE);
const onSearchOpen			= ()		=> genericPlayerEvent(playerActionTypes.PLAYER_SEARCH_OPEN);
const onSearchPerform		= ()		=> genericPlayerEvent(playerActionTypes.PLAYER_SEARCH_PERFORM);
const onSearchClose			= ()		=> genericPlayerEvent(playerActionTypes.PLAYER_SEARCH_CLOSE);

// EVENT-MAPPINGS ##########################################################

// player events mappings
export const playerEventsMap = {
	[playerActionTypes.PLAYER_PLAY_LOAD]            : onPlayLoad,
	[playerActionTypes.PLAYER_PLAY_RESUME]          : onPlayResume,
	[playerActionTypes.PLAYER_PLAY_PAUSE]           : onPlayPause,
	[playerActionTypes.PLAYER_SKIP_FORWARD]         : onPlayForward,
	[playerActionTypes.PLAYER_SKIP_BACKWARD]        : onPlayBack,
	[playerActionTypes.PLAYER_VOLUME_CHANGE]        : onVolumeChange,
	[playerActionTypes.PLAYER_SPEED_CHANGE]         : onSpeedChange,
	[playerActionTypes.PLAYER_FULL_VIEW_LOAD]       : onFullViewLoad,
	[playerActionTypes.PLAYER_FULL_VIEW_EXIT]       : onFullViewExit,
	[playerActionTypes.PLAYER_GIST_SHOW]            : onGistShow,
	[playerActionTypes.PLAYER_GIST_HIDE]            : onGistHide,
	[playerActionTypes.PLAYER_GIST_LOGO_REDIRECT]   : onGistLogoRedirect,
	[playerActionTypes.PLAYER_GIST_WORD_PLAY]       : onGistWordPlay,
	[playerActionTypes.PLAYER_GIST_HINT_SHOW]       : onGistWordHint,
	[playerActionTypes.PLAYER_CHAPTER_CHANGE]       : onChapterChange,
	[playerActionTypes.PLAYER_TOC_VIEW_LOAD]        : onTocViewLoad,
	[playerActionTypes.PLAYER_TOC_VIEW_TO_CHAPTER]  : onTocToChapter,
	[playerActionTypes.PLAYER_TOC_VIEW_CLOSE]       : onTocViewClose,
	[playerActionTypes.PLAYER_SEARCH_OPEN]			: onSearchOpen,
	[playerActionTypes.PLAYER_SEARCH_PERFORM]		: onSearchPerform,
	[playerActionTypes.PLAYER_SEARCH_CLOSE]			: onSearchClose,
};